var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffchainLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77124 5.72403L3.77124 4.20853C3.77124 2.70195 4.99256 1.48062 6.49914 1.48062V1.48062C8.00572 1.48062 9.22705 2.70195 9.22705 4.20853V5.72403",
    stroke: "#636366",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.57617 5.2666C11.0252 5.26683 12.2002 6.44157 12.2002 7.89062V11.4424C12.2002 12.8915 11.0252 14.0662 9.57617 14.0664H3.42383C1.97472 14.0663 0.799805 12.8915 0.799805 11.4424V7.89062C0.799839 6.44151 1.97474 5.26674 3.42383 5.2666H9.57617ZM6.49902 8.77441C5.99709 8.77463 5.58997 9.18164 5.58984 9.68359C5.58984 10.1857 5.99702 10.5926 6.49902 10.5928C7.00122 10.5928 7.40918 10.1858 7.40918 9.68359C7.40906 9.1815 7.00114 8.77441 6.49902 8.77441Z",
    fill: "#636366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffchainLight);
export default __webpack_public_path__ + "static/media/offchain_light.79adc27d2e9565021fdd1c4bcb0ef7a3.svg";
export { ForwardRef as ReactComponent };